// The Overview's default period, apart from the query hooks so the route's `validateSearch` stays out of the API client bundle.
import type { AnalyticsRangePreset } from '@repo/shared/marketing';

/** The Overview period New Client Offer opens on (kept out of the URL). */
export const DEFAULT_OFFER_OVERVIEW_RANGE: AnalyticsRangePreset = '30d';
